import { render, staticRenderFns } from "./UserDailyEnquetes.vue?vue&type=template&id=298f52fe&scoped=true&"
import script from "./UserDailyEnquetes.vue?vue&type=script&lang=js&"
export * from "./UserDailyEnquetes.vue?vue&type=script&lang=js&"
import style0 from "./UserDailyEnquetes.vue?vue&type=style&index=0&id=298f52fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f52fe",
  null
  
)

export default component.exports